import { Component } from '@angular/core';
import { OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AlertsService } from '../../../services/alerts.service';
import { UserService } from '../../../services/user.service';
import { TaskService } from '../../services/task.service';
import { formatString } from '../../../utils/string-utils';
import dayjs from 'dayjs';

/**
 * Component for managing workflow task completion.
 */
@Component({
	selector: 'workflow-task-completion',
	templateUrl: './task-completion.component.html',
	styleUrl: './task-completion.component.css'
})
export class TaskCompletionComponent implements OnInit {
	@Input() taskGroup: any;

	LOCALIZATION: any;

	//potentialOwners: any[] = [];

	// NOTE: The feature allowing dynamic task completion templates is deprecated (AFDO pilot)
	//	taskDataForms = [
	//		{ name: 'basicTaskData', url: 'app/js/workflow/dynamic/basicTaskData.html' },
	//		{ name: 'afdoTaskData', url: 'app/js/workflow/dynamic/afdoTaskData.html' },
	//		{ name: 'sf715TaskData', url: 'app/js/workflow/dynamic/sf715TaskData.html' }
	//	];
	//	var formName = this.customize.taskDataForm ? this.customize.taskDataForm.name : 'basicTaskData';
	//	this.taskDataForm = $filter("filter")(this.taskDataForms, { name: formName })[0];	

	reviewDate: string = "";
	inprogress: boolean = false;

	constructor(
		private modalService: NgbActiveModal,
		private alertsService: AlertsService,
		private taskService: TaskService,
		private userService: UserService,
	) { }

	ngOnInit(): void {
		this.LOCALIZATION = this.userService.LOCALIZATION;

		this.reviewDate = dayjs().format("MM/DD/YYYY");

		if (this.taskGroup.canSave) {
			this.getSavedFormData();
		} else {
			this.loadFormData();
		}
	}

	//		this.$watch('taskGroup.userTaskData.decision', function (value) {
	//			if (value != 'Refer') {
	//				this.taskGroup.userTaskData.referto = null;
	//			}
	//		});	

	private loadFormData(): void {
		this.taskGroup.userTaskData = {};

		//			/*
		//			 * Deprecated (AFDO pilot) 
		//			 */
		//			var payload = {
		//				annotations: this.taskGroup.annotations
		//			};		
		//			if ('afdoTaskData' == this.taskDataForm.name) {
		//				taskService.getSF715TaskDecision(payload).then(function (result) {
		//					this.taskGroup.userTaskData = result;
		//					this.taskGroup.userTaskData.reviewDate = this.reviewDate;
		//				}, function (response) {
		//					this.taskGroup.userTaskData.reviewDate = this.reviewDate;
		//					console.log("Unable to get the recommended decision for the task.");
		//				});
		//			}
		//			else if ('sf715TaskData' == this.taskDataForm.name) {
		//				var reviewingAgency = this.customize.name || "";
		//				taskService.getSF715TaskDecision(payload).then(function (result) {
		//					this.taskGroup.userTaskData = result;
		//					this.taskGroup.userTaskData.reviewingAgency = reviewingAgency;
		//					this.taskGroup.userTaskData.reviewDate = this.reviewDate;
		//				}, function (response) {
		//					this.taskGroup.userTaskData.reviewingAgency = reviewingAgency;
		//					this.taskGroup.userTaskData.reviewDate = this.reviewDate;
		//					console.log("Unable to get the recommended decision for the task.");
		//				});
		//			}		
	}

	private getSavedFormData(): void {
		let id = this.taskGroup.taskids[0];
		this.taskService.getTaskData(id).then(
			(response: any) => {
				this.taskGroup.userTaskData = response.data;
				this.taskGroup.userTaskData.reviewDate = this.reviewDate;
			},
			(err: any) => {
				console.log("No saved form data found for the task.");
				this.taskGroup.userTaskData = null;
				this.loadFormData();
			}
		);
	}

	/**
	 * Completes the tasks.
	 */
	completeTasks(): void {
		this.inprogress = true;

		let payload = {
			taskIds: this.taskGroup.taskids,
			comment: this.taskGroup.comment,
			ownerId: this.taskGroup.owner,
			taskData: JSON.stringify(this.taskGroup.userTaskData)
		};

		this.taskService.massComplete(payload).then(
			(response: any) => {
				this.alertsService.success({
					message: formatString(this.LOCALIZATION.completedTasks, ((this.taskGroup.taskids.length > 1) ? "tasks were" : "task was")),
					delay: 5000
				});
				// Closes the main editor window, if open
				this.proceed();
			},
			(err: any) => {
				console.error("Failed to complete tasks", err);
				
				let errMsg = formatString(this.LOCALIZATION.completedTasksError, ((this.taskGroup.taskids.length > 1) ? "tasks" : "task"));
				if (err.error) {
					errMsg += " " + err.error;
				}
				
				this.alertsService.error({
					message: errMsg,
				});
				this.inprogress = false;
			}
		);
	}

	/**
	 * Saves the task.
	 * Deprecated (AFDO pilot) 
	 */
	saveTask(): void {
		this.inprogress = true;

		let id = this.taskGroup.taskids[0];
		let payload = {
			comment: this.taskGroup.comment,
			ownerId: this.taskGroup.owner,
			taskData: JSON.stringify(this.taskGroup.userTaskData)
		};

		this.taskService.saveTaskData(id, payload).then(
			(response: any) => {
				this.alertsService.success({
					message: "The task was saved successfully.",
					delay: 5000
				});
				this.close();
			},
			(err: any) => {
				console.error("Failed to save the task", err);
				this.alertsService.error({
					message: formatString(this.LOCALIZATION.completedTasksError, ((this.taskGroup.taskids.length > 1) ? "tasks" : "task")),
				});
				this.inprogress = false;
			}
		);
	}

	//		/*
	//		* Deprecated (AFDO Air Force pilot)
	//		*/
	//		this.openDecisionJustification = function (event) {
	//			var justification = this.taskGroup.userTaskData ? this.taskGroup.userTaskData.justification : [];
	//			console.log('Decision justification:');
	//			console.log(justification);
	//
	//			var modalInstance = $uibModal.open({
	//				animation: this.animationsEnabled,
	//				templateUrl: '~/../app/js/workflow/dynamic/sf715Justification.html',
	//				windowClass: 'dx-modal dx-medium-modal-window',
	//				controller: 'DXDecisionJustificationCtrl',
	//				resolve: {
	//					decisionData: function () {
	//						return {
	//							title: "Decision Justification",
	//							data: justification
	//						}
	//					}
	//				}
	//			});
	//		}

	/**
	 * Closes the modal, returning a result of ok and payload.
	 */
	proceed(): void {
		let caller = {
			callerName: 'workflowTaskCompletion'
		};

		this.modalService.close({
			result: { answer: 'ok', caller: caller },
			timestamp: new Date(),
		});
	}

	/**
	 * Closes the modal.
	 */
	close(): void {
		this.modalService.dismiss();
	}
}
